import apiClientAdmin from './indexAdmin'
import axiosInstanceAdmin from './indexAdmin'
import { useUserStore } from '@/stores/userStore'
import Cookies from 'universal-cookie'
import { STAGE } from '@/env'
export const fetchAccounts = async (options?: {
  productNames?: string[]
  limit?: number
  nextToken?: string
  search?: string
  status?: 'active' | 'inactive' | 'all'
}) => {
  try {
    const userStore = useUserStore()

    let endPoint = '/account/get_accounts'
    const params = new URLSearchParams()

    // If productNames array has values, add them as query parameters
    if (options?.productNames && options.productNames.length > 0) {
      options.productNames.forEach((name) => {
        params.append('productName', name)
      })
    }

    // Add pagination and filter parameters
    if (options?.limit) {
      params.append('limit', String(options.limit))
    }
    if (options?.nextToken) {
      params.append('nextToken', options.nextToken)
    }
    if (options?.search) {
      params.append('search', options.search)
    }
    if (options?.status) {
      params.append('status', options.status)
    }

    if (params.toString()) {
      endPoint += `?${params.toString()}`
    }

    const response = await axiosInstanceAdmin.get(endPoint, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)

    throw error
  }
}
export const VerifyAdmin = async () => {
  const userStore = useUserStore()

  try {
    // Checking if the token is available and valid
    if (!userStore.token) {
      throw new Error('Token is missing')
    }

    // Send request to verify the token is valid
    const response = await axiosInstanceAdmin.get('/company/verify', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })

    return response.data
  } catch (error) {
    if (window.location.pathname === '/' || window.location.pathname === '/company/login') {
      console.log('Irrelevant')
    } else {
      window.location.href = '/'
      userStore.clearUser()
      localStorage.clear()
    }

    console.error('Error verifying admin token:', error)
    throw error // Rethrow error to handle it appropriately in the calling function
  }
}
export const VerifyUsers = async () => {
  const cookie = new Cookies()
  const user = cookie.get('user')
  try {
    const response = await apiClientAdmin.get('/account/user/verify', {
      headers: {
        Authorization: `Bearer ${user?.idToken}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const toggleAccountStatus = async (name: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.put(
      `/account/toggle_disable?accountName=${name}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error toggling  accounts:', error)
    alert(error)
    throw error
  }
}

export const toggleAccountProductStatus = async (accountName: string, productName: string) => {
  try {
    const response = await apiClientAdmin.put(
      `amount/product/toggle_disable?productName=${productName}&accountName=${accountName}`
    )
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const toggleProductForAccount = async (accountName: string, productName: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.put(
      `/account/products/toggle_disable?accountName=${accountName}&productName=${productName}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const toggleProductStatus = async (name: string) => {
  const userStore = useUserStore()
  try {
    const response = await apiClientAdmin.put(
      `/product/toggle_disable?productName=${name}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const fetchProducts = async () => {
  try {
    // await VerifyAdmin()
    const userStore = useUserStore()
    const response = await axiosInstanceAdmin.get('/product', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)

    throw error
  }
}

export const fetchAllProductsFromIndex = async () => {
  try {
    const userStore = useUserStore()
    const response = await axiosInstanceAdmin.get('/product/hierarchy/all', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error: any) {
    console.error('Error fetching all products from index:', error)
    throw error
  }
}

export const fetchParentProducts = async (options?: {
  limit?: number
  nextToken?: string
  search?: string
  status?: 'active' | 'inactive' | 'all'
}) => {
  try {
    const userStore = useUserStore()
    let endpoint = '/product/parents'
    const params = new URLSearchParams()
    if (options?.limit) params.append('limit', String(options.limit))
    if (options?.nextToken) params.append('nextToken', options.nextToken)
    if (options?.search) params.append('search', options.search)
    if (options?.status) params.append('status', options.status)
    if (params.toString()) endpoint += `?${params.toString()}`
    const response = await axiosInstanceAdmin.get(endpoint, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching parent products:', error)
    throw error
  }
}

export const fetchClients = async () => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.get(`/account/clients`, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Error fetching accounts: hello', error)

    throw error
  }
}

export const fetchAccountProductsAdmin = async (accountName: string, productName: string) => {
  const userStore = useUserStore()
  try {
    // URL-encode productName to handle slashes in child product paths
    const encodedProductName = encodeURIComponent(productName)
    const response = await axiosInstanceAdmin.get(
      `/account/products/${accountName}/${encodedProductName}`,
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response);

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)

    throw error
  }
}

export const updateProductForAccount = async (data: any) => {
  const userStore = useUserStore()
  try {
    // URL-encode productName to handle slashes in child product paths
    const encodedProductName = encodeURIComponent(data.productName)
    const response = await axiosInstanceAdmin.put(
      `/account/products/${data.accountName}/${encodedProductName}`,
      { config: data.config },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not create account Products', error)
    throw error
  }
}

export const sampleCreateProductsForAccount = async (data: object) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.post('/account/products', data, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,

        'Content-Type': 'application/json',
      },
    })
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not create account Products', error)
    throw error
  }
}

export const deleteProductFromAccount = async (accountName: string, productName: string) => {
  const userStore = useUserStore()
  try {
    // URL-encode productName to handle slashes in child product paths
    const encodedProductName = encodeURIComponent(productName)
    const response = await axiosInstanceAdmin.delete(
      `/account/products/${accountName}/${encodedProductName}`,
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Could not delete product from account', error)
    throw error
  }
}

export const fetchAccountProductsConfig = async (productConfig: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.get(`/product/config/`, {
      params: {
        productName: productConfig,
      },

      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const fetchAccountsProduct = async (accountName: string) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.get(`/account/products`, {
      params: {
        accountName: accountName,
      },

      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const createAccountProductsConfig = async (data: object) => {
  const userStore = useUserStore()
  try {
    const response = await apiClientAdmin.post('/product/config', data, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not create account Products', error)
    alert('Failed to create account product.')
    throw error
  }
}

export const updateAccountProductsConfig = async (data: object) => {
  try {
    const response = await apiClientAdmin.put('/product/config', data)
    // console.log(response);
    return response.data
  } catch (error) {
    console.error('Could not update account Products', error)
    alert('Failed to update account product.')
    throw error
  }
}

export const moveProductPath = async (oldPath: string, newPath: string) => {
  const userStore = useUserStore()
  try {
    const response = await apiClientAdmin.put(
      '/product/move',
      { oldPath, newPath },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Failed to move product', error)
    throw error
  }
}

export const createAccount = async (accountData: object) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.post('/account', accountData, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log("Account DataSubmitted", response);
    return response.data
  } catch (error) {
    console.error('Could not create account', error)
    alert('Failed to create account.')
    throw error
  }
}

export const updateAccount = async (payload: object) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.put('/account', payload, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // console.log("Account Updated successfully", response);
    return response.data
  } catch (error) {
    console.error('Could not update account', error)
    // alert("Failed to update account.");

    throw error
  }
}

export const fetchAccountSingle = async (accountName: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.get(`/account`, {
      params: {
        accountName: accountName,
      },
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)

    throw error
  }
}

export const fetchAllUsers = async () => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.get('/company/get-all-users', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    console.log(error.status)

    throw error
  }
}

export const SendUserName = async (username: string, group: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.post(
      '/company/add-user-group',
      { username: username, group: group },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    console.log('User Name Submitted', response)
    return response.data
  } catch (error) {
    console.error('Could not create User', error)
    alert('Failed to send Username.')
    throw error
  }
}

export const SendAdminName = async (username: string, email: string) => {
  try {
    const response = await apiClientAdmin.post('/unauth/add-group', {
      username: username,
      email: email,
    })
    console.log('Admin Name Submitted', response)

    return response.data
  } catch (error) {
    console.error('Could not create User', error)
    alert('Failed to send Username.')
    throw error
  }
}

export const fetchAllClients = async () => {
  try {
    const userStore = useUserStore()
    // await VerifyAdmin()
    const response = await axiosInstanceAdmin.get('/company/get-all-clients', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    console.log(response.status)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    console.log(error.status)
    console.log(error.response.status)
    throw error
  }
}

export const LogoutFunc = async () => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.get('/company/logout', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}
export const deleteUser = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.delete('/company/delete-user', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
      params: {
        username: username,
      },
    })
    console.log(response.status)
    console.log('logout func', response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const LogoutFuncUser = async () => {
  const cookie = new Cookies()
  const user = cookie.get('user')
  try {
    const response = await axiosInstanceAdmin.get('/logout', {
      headers: {
        Authorization: `Bearer ${user?.idToken}`,
        'Content-Type': 'application/json',
      },
    })
    console.log(response.status)
    console.log('logout func', response)
    alert(response?.data?.message)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const toggleUserStatusSetActiveNow = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.put(
      `/company/enable-user`,
      { username },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error Enable User status:', error)
    throw error
  }
}
export const toggleUserStatusSetActiveNowClient = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.put(
      `/company/enable-client`,
      { username },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error Enable User status:', error)
    throw error
  }
}
export const toggleUserStatusSetDeActiveNowClient = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.put(
      `/company/disable-client`,
      { username },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error Disable user status:', error)
    throw error
  }
}

export const toggleUserStatusSetDeActiveNow = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.put(
      `/company/disable-user`,
      { username },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )

    return response.data
  } catch (error) {
    console.error('Error Disable user status:', error)
    throw error
  }
}

export const getClientsAtAddUser = async (accountName: string) => {
  try {
    // await VerifyAdmin()
    const userStore = useUserStore()
    const response = await axiosInstanceAdmin.get('/get-client', {
      params: {
        accountName: accountName,
      },
      headers: {
        Authorization: `Bearer ${userStore.token}`,
      },
    })
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)

    throw error
  }
}

export const deleteUserClients = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.delete('/company/delete-client', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
      params: {
        username: username,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching accounts:', error)
    throw error
  }
}

export const resendVerificationEmailCompany = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.post(
      '/company/resend-verification',
      {
        username: username,
      },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error resending verification email:', error)
    throw error
  }
}

export const resendVerificationEmailClientByCompany = async (username: string) => {
  const userStore = useUserStore()

  try {
    const response = await axiosInstanceAdmin.post(
      '/company/resend-verification-client',
      {
        username: username,
      },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error resending verification email for client:', error)
    throw error
  }
}

// ==================== NEW USER CREATION FLOW WITH INVITATION EMAIL ====================

/**
 * Creates a new user with email only (no password required from admin)
 * Cognito sends invitation email with temporary password automatically
 * Uses /company/create-user for company admins, /client/create-user for client admins
 */
export const createUserSimple = async (
  username: string,
  email: string,
  group: string,
  juid?: string
) => {
  const userStore = useUserStore()

  // Determine endpoint based on user role
  const isClientAdmin = userStore.role?.startsWith('client_')
  const endpoint = isClientAdmin ? '/client/create-user' : '/company/create-user'

  try {
    const response = await axiosInstanceAdmin.post(
      endpoint,
      {
        username,
        email,
        group,
        juid, // optional, for client users
      },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error creating user:', error)
    throw error
  }
}

/**
 * Resends the invitation email with temporary password
 * Only works for users who haven't completed account setup
 * Uses /company/resend-invitation for company admins, /client/resend-invitation for client admins
 */
export const resendInvitation = async (username: string, poolType: 'client' | 'company') => {
  const userStore = useUserStore()

  // Determine endpoint based on user role
  const isClientAdmin = userStore.role?.startsWith('client_')
  const endpoint = isClientAdmin ? '/client/resend-invitation' : '/company/resend-invitation'

  try {
    const response = await axiosInstanceAdmin.post(
      endpoint,
      {
        username,
        poolType,
      },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error resending invitation:', error)
    throw error
  }
}

export const updateRole = async (username: string, newRole: string, isClient: boolean) => {
  const userStore = useUserStore()
  try {
    const response = await axiosInstanceAdmin.put(
      `/company/change-role`,
      {
        username: username,
        newRole: newRole,
        isClient: isClient,
      },
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    // console.log(response)
    return response.data
  } catch (error) {
    console.error('Error toggling  accounts:', error)
    alert(error)
    throw error
  }
}

export const getParentAccount = async () => {
  try {
    const userStore = useUserStore()
    const response = await axiosInstanceAdmin.get('/product/parents/1-level', {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
      },
    })
    return response
  } catch (error) {
    console.error('Error fetching accounts:', error)

    throw error
  }
}

export const getParentChild = async (productName: string) => {
  try {
    const userStore = useUserStore()
    const response = await axiosInstanceAdmin.get(
      `/product/${encodeURIComponent(productName)}/children`,
      {
        headers: {
          Authorization: `Bearer ${userStore.token}`,
        },
      }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching children:', error)

    throw error
  }
}

export const getFilteredProductsForAccount = async (juid: string) => {
  try {
    const userStore = useUserStore()
    const response = await axiosInstanceAdmin.get(`/product/available`, {
      params: {
        accountName: juid,
      },
      headers: {
        Authorization: `Bearer ${userStore.token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching children:', error)

    throw error
  }
}

export const sendLogInfo = async (logInfo: object) => {
  const userStore = useUserStore()
  console.log(logInfo)
  try {
    const response = await axiosInstanceAdmin.post(`/account/login-activity`, logInfo, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
        'Content-Type': 'application/json',
      },
    })
    // alert("Success");

    return response.data
  } catch (error) {
    console.error('Error toggling  accounts:', error)
    alert(error)
    throw error
  }
}

export const getLoggedData = async (
  params: {
    limit?: number
    user?: string
    activity?: string
    lastEvaluatedKey?: string
  } = {}
) => {
  try {
    const userStore = useUserStore()
    // Build query parameters
    const queryParams = new URLSearchParams()
    if (params.limit) queryParams.append('limit', params.limit.toString())
    if (params.user) queryParams.append('user', params.user)
    if (params.activity) queryParams.append('activity', params.activity)
    if (params.lastEvaluatedKey) queryParams.append('lastEvaluatedKey', params.lastEvaluatedKey)

    const url = `/account/activity-logs${queryParams.toString() ? `?${queryParams.toString()}` : ''}`

    console.log('API URL:', url)
    console.log('Query params:', queryParams.toString())

    const response = await axiosInstanceAdmin.get(url, {
      headers: {
        Authorization: `Bearer ${userStore.token}`,
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching activity logs:', error)
    throw error
  }
}

// ==================== WORDPRESS SSO CONNECTIONS ====================

export type JamsUserType = 'company' | 'client'

export interface SSOConnection {
  id: string
  wpUrl: string
  wpUsername: string
  wpEmail: string
  token: string
  userType: JamsUserType
  createdAt: string
  meta?: Record<string, any>
}

export const getSSOConnections = async (): Promise<{ connections: SSOConnection[] }> => {
  const userStore = useUserStore()
  const isClientUser = userStore.role?.startsWith('client')
  const endpoint = isClientUser ? '/client/sso/connections' : '/company/sso/connections'

  const response = await axiosInstanceAdmin.get(endpoint, {
    headers: {
      Authorization: `Bearer ${userStore.token}`,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const createSSOConnection = async (payload: {
  wpUrl: string
  token: string
  wpUsername: string
  wpEmail: string
  userType?: JamsUserType
  meta?: Record<string, any>
}): Promise<SSOConnection> => {
  const userStore = useUserStore()
  const isClientUser = userStore.role?.startsWith('client')
  const endpoint = isClientUser ? '/client/sso/connections' : '/company/sso/connections'

  const response = await axiosInstanceAdmin.post(endpoint, payload, {
    headers: {
      Authorization: `Bearer ${userStore.token}`,
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const deleteSSOConnection = async (id: string): Promise<void> => {
  const userStore = useUserStore()
  const isClientUser = userStore.role?.startsWith('client')
  const endpoint = isClientUser
    ? `/client/sso/connections/${encodeURIComponent(id)}`
    : `/company/sso/connections/${encodeURIComponent(id)}`

  await axiosInstanceAdmin.delete(endpoint, {
    headers: {
      Authorization: `Bearer ${userStore.token}`,
      'Content-Type': 'application/json',
    },
  })
}
